const EN_FLAG_IMAGE = [
  {
    src: new URL(
      '~/public/assets/images/languages/en.png?as=webp',
      import.meta.url
    ).href,
    alt: 'EN',
    as: 'image/webp'
  },
  {
    src: new URL('~/public/assets/images/languages/en.png', import.meta.url)
      .href,
    alt: 'EN',
    as: 'image/png'
  }
]

export default EN_FLAG_IMAGE
